"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    flag: {
      width: 35,
      paddingRight: 15,
      marginTop: 4
    },
    value: {
      paddingRight: 20
    },
    label: {
      color: 'grey'
    }
  };
}, {
  name: 'CurrencySelect'
});
exports.useStyles = useStyles;